<template>
  <div class="d-flex align-items-end">
    <div class="form-group m-0 mx-2">
      <label class="form-control-label">Buscar razón social</label>
      <base-input v-model="searchQuery" placeholder="Buscar razón social..." class="m-0" />
    </div>

    <base-input v-if="isBySeller" label="Asesor Técnico" class="my-0 mx-2">
      <el-autocomplete
        v-model="sellerSelected"
        cy-id="seller-select"
        placeholder="Seleccione Asesor Técnico"
        :fetch-suggestions="sellerOptions"
        @select="onSellerSelected"
      />
    </base-input>

    <base-input v-else label="Distribuidor" class="my-0 mx-2">
      <el-autocomplete
        v-model="distributorSelected"
        cy-id="distributor-select"
        placeholder="Seleccione Distribuidor"
        :fetch-suggestions="distributorOptions"
        @select="onDistributorSelected"
      />
    </base-input>

    <base-input label="Campaña" class="my-0 mx-2">
      <el-select v-model="campaignSelected" cy-id="campaign-select" placeholder="Seleccione Campaña">
        <el-option :key="0" label="Todos" :value="null" class="select-primary"> </el-option>
        <el-option
          v-for="item in campaigns"
          :key="item.id"
          :label="item.name"
          :value="item.id"
          cy-id="campaign-options"
          class="select-primary"
        >
        </el-option>
      </el-select>
    </base-input>

    <base-input label="Fechas" class="my-0 mx-2">
      <el-date-picker
        v-model="rangeDates"
        align="center"
        type="daterange"
        range-separator="-"
        start-placeholder="Fecha Inicio"
        end-placeholder="Fecha Fin"
        format="dd-MM-yyyy"
        value-format="yyyy-MM-dd"
      />
    </base-input>
  </div>
</template>

<script>
import { Autocomplete, Select, Option, DatePicker } from 'element-ui';
import { mapState } from 'vuex';

export default {
  name: 'LiquidationFilters',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Autocomplete.name]: Autocomplete,
  },

  props: {
    isBySeller: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      searchQuery: null,
      sellers: [],
      distributors: [],
      sellerSelected: null,
      distributorSelected: null,
      campaignSelected: null,
      rangeDates: null,
    };
  },

  computed: {
    ...mapState('models/campaign', ['campaigns']),
  },

  watch: {
    searchQuery(query) {
      let timerId;

      timerId = setTimeout(() => {
        if (this.searchQuery === query) {
          this.$emit('search', query);
        }
        clearTimeout(timerId);
      }, 1000);
    },

    campaignSelected(campaignId) {
      this.$emit('campaignSelect', campaignId);
    },

    rangeDates(rangeDates) {
      if (rangeDates) {
        this.$emit('rangeDates', rangeDates[0], rangeDates[1]);
      } else {
        this.$emit('rangeDates', null, null);
      }
    },
  },

  mounted() {
    this.fetchDistributors();
    this.fetchSellers();
  },

  methods: {
    fetchSellers() {
      const params = {
        sort: 'name',
      };

      this.$services
        .resource('sellers')
        .get(params)
        .then((res) => res.data.data)
        .then((data) => {
          this.sellers = data.sellers.map((seller) => ({ id: seller.id, value: seller.name }));
        });
    },

    fetchDistributors() {
      const params = {
        sort: 'name',
        for_select: true,
      };

      this.$services
        .resource('distributors')
        .get(params)
        .then((res) => res.data.data)
        .then((data) => {
          this.distributors = data.distributors.map((distributor) => ({
            id: distributor.id,
            value: distributor.name,
          }));
        });
    },

    onSellerSelected(seller) {
      this.$emit('sellerSelect', seller.id);
    },

    onDistributorSelected(distributor) {
      this.$emit('distributorSelect', distributor.id);
    },

    sellerOptions(query, cb) {
      const options = [{ value: 'Todos', id: null }].concat(this.sellers);

      cb(
        options.filter((option) => {
          return option.value.toLowerCase().indexOf(query ? query.toLowerCase() : '') >= 0;
        })
      );
    },

    distributorOptions(query, cb) {
      const options = [{ value: 'Todos', id: null }].concat(this.distributors);

      cb(
        options.filter((option) => {
          return option.value.toLowerCase().indexOf(query ? query.toLowerCase() : '') >= 0;
        })
      );
    },
  },
};
</script>

<style scoped>
::v-deep input {
  max-height: 40px;
}
</style>
